import { getSubscriptionStreamToken, streamHistoryHeartbeat, postVideoAssetService2 } from '@engage/api-v2';
import { engageApi } from '../lib/singletons';
import { unwrap } from '../lib/unwrap';
import { toFetcher } from './toFetcher'; // 30 seconds

var HEARTBEAT = 30 * 1000;
export var toStreamFetchers = function toStreamFetchers() {
  var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : engageApi;
  return {
    CreateStream: toFetcher(function (params) {
      return "CreateStream".concat(params.currentStartTime);
    }, function () {
      return unwrap(function () {
        return getSubscriptionStreamToken(api);
      });
    }, {
      revalidateIfStale: true
    }),
    Hearbeat: toFetcher(function (params) {
      return "StreamHeartbeat".concat(params.streamHistoryId);
    }, function (params) {
      return unwrap(function () {
        return streamHistoryHeartbeat(api, params.streamHistoryId);
      });
    }, {
      refreshInterval: HEARTBEAT,
      dedupingInterval: HEARTBEAT,
      shouldRetryOnError: false
    }),
    CreateAkamaiStream: toFetcher(function (params) {
      return "GetStream".concat(params.rideId).concat(params.currentStartTime);
    }, function (params) {
      return unwrap(function () {
        var _params$streamSource;

        return postVideoAssetService2(api, params.rideId, params.contentType, (_params$streamSource = params.streamSource) !== null && _params$streamSource !== void 0 ? _params$streamSource : 'primary');
      });
    })
  };
};